// extracted by mini-css-extract-plugin
export default {"commentBody":"CommentBody_commentBody__+95h8","content":"CommentBody_content__+L-co"};